export enum notificationtype {
  scheduled=1,
  actionTriggered=2
}

export const notificationtype2LabelMapping = {
  [notificationtype.scheduled]: "1",
  [notificationtype.actionTriggered]: "2",
}
